export default {
  status: "",
  token: localStorage.getItem("token") || "",
  user: null,
  expiresDate: "",
  isSubscribed: false,
};
